import { Schema as S } from "effect";
import { SchedulePayloadSchema } from "../schedule-payload.schema";

/**
 * Validated schedule payload after the SDK removes the vendor envelope.
 *
 * @since 1.1.8
 * @example
 * ```ts
 * S.decodeUnknownResult(FindScheduleResponseSchema)([]);
 * ```
 */
export const FindScheduleResponseSchema = S.Array(SchedulePayloadSchema);

/**
 * Vendor schedules including explicit closure evidence.
 *
 * @since 1.1.8
 * @example
 * ```ts
 * const schedules: FindScheduleResponse = [];
 * ```
 */
export type FindScheduleResponse = S.Schema.Type<typeof FindScheduleResponseSchema>;
